import gql from 'graphql-tag';

const UPDATE_GROWTH_REPORT_CONFIG = gql`
  mutation($input: OfferedItemStatusInput!) {
    updateReportCalculationStatus(input: $input)
  }
`;

export { UPDATE_GROWTH_REPORT_CONFIG };
